import script from "./SdButton.vue?vue&type=script&lang=js"
export * from "./SdButton.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__